__turbopack_context__.v({
  "body": "policy-module-scss-module__bejEcq__body",
  "breadcrumbs": "policy-module-scss-module__bejEcq__breadcrumbs",
  "time": "policy-module-scss-module__bejEcq__time",
});
